import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

type StepFooterProps = {
  onBack?: () => void;
  onContinue?: () => void;
  continueDisabled?: boolean;
  cancelLabel?: string;
  cancelTo?: string;
};

/** Report wizard navigation, using the existing report button styles. */
const StepFooter: React.FunctionComponent<StepFooterProps> = ({
  onBack,
  onContinue,
  continueDisabled = false,
  cancelLabel,
  cancelTo = "/polestar/reports/adhoc",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <footer className="flex gap-4 p-6 border-t border-gray-200 mt-auto">
      {onBack && (
        <button type="button" className="btn-outline-primary" onClick={onBack}>
          {t("common.back")}
        </button>
      )}
      {onContinue && (
        <button
          type="button"
          className="btn-primary"
          disabled={continueDisabled}
          onClick={onContinue}
        >
          {t("common.continue")}
        </button>
      )}
      <button
        type="button"
        className="btn-outline-primary"
        onClick={() => navigate(cancelTo)}
      >
        {cancelLabel ?? t("common.cancel")}
      </button>
    </footer>
  );
};

export default StepFooter;
